module.exports = __webpack_public_path__ + "static/media/gdpr-reality.a7cf418e.pdf";